<template>
  <el-dialog
    width="600px"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <h1>{{ $t('NewMxaUpsell_Title') }}</h1>
    <img src="@/img/jb-2.0-upsell.svg" :alt="$t('Campaign_Dialog_NewMxa')" />
    <div class="upsell-text">
      <h1>{{ $t('NewMxaUpsell_WhatsNew') }}</h1>
      <ul>
        <li>{{ $t('NewMxaUpsell_Bullet1') }}</li>
        <li>{{ $t('NewMxaUpsell_Bullet2') }}</li>
        <li>{{ $t('NewMxaUpsell_Bullet3') }}</li>
      </ul>
      <h1>{{ $t('NewMxaUpsell_GetInvolved') }}</h1>
      <p>{{ $t('NewMxaUpsell_SendRequestDescription') }}</p>
    </div>
    <div class="upsell-buttons">
      <el-button @click="close">{{ $t('NewMxaUpsell_Cancel') }}</el-button>
      <el-button type="primary" @click="sendRequest">{{
        $t('NewMxaUpsell_SendRequest')
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { ProductRequestTypesEnum } from '@/common/enum/ProductRequestTypesEnum'
import store from '@/core/store'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'NewMxaUpsellDialog',

  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    close() {
      this.$emit('upsell-close')
    },
    sendRequest() {
      RestApi({
        method: 'post',
        url: `projects/${store.getters.projectId}/notification`,
        data: {
          productName: ProductRequestTypesEnum.JOURNEY_BUILDER_2
        }
      })
        .then(() => {
          this.$message({
            message: this.$t('NewMxaUpsell_Popup_RequestSent'),
            type: 'success'
          })
        })
        .catch(() => {
          this.$message({
            message: this.$t('NewMxaUpsell_Popup_RequestFailed'),
            type: 'error'
          })
        })
      this.close()
    }
  }
}
</script>
<style scoped lang="scss">
>>> .el-dialog__header {
  display: none;
}

>>> .el-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  word-break: break-word;
  font-size: 13px;
  max-height: 90vh;
  overflow-y: auto;
}

h1 {
  font-size: 17.5px;
}

img {
  margin: 10px;
  width: 547;
  height: 250px;
}

.upsell-text {
  margin: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

ul {
  padding: 15px;
  list-style: disc;
}

li {
  margin-bottom: 15px;
}

li:last-child {
  margin-bottom: 0px;
}

.upsell-buttons {
  width: 100%;
  display: flex;
  justify-content: right;
  margin-top: 10px;
  margin-bottom: 10px;
}

.el-button {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/NewMxaUpsellDialog.vue